// extracted by mini-css-extract-plugin
export var button = "button-module--button--KCsdZ";
export var bg_second = "button-module--bg_second--h0S+m";
export var bg_first = "button-module--bg_first--nauE2";
export var text_first = "button-module--text_first--FV7kc";
export var text_second = "button-module--text_second--Npsoi";